import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DataSourceFilter, DataSourceResponse, Clinic, Department, Diagnose } from "../../models";
import { ManualApi } from "../base";
import { ClinicService, DepartmentService, DiagnoseService } from '../services';

@Injectable()
export class RestManualApi extends ManualApi {
  getClinics(filter: DataSourceFilter): Observable<DataSourceResponse<Clinic>> {
    return this.clinicService.getList(filter);
  }
  getDepartments(filter: DataSourceFilter): Observable<DataSourceResponse<Department>> {
    return this.departmentService.getList(filter);
  }
  getDiagnoses(filter: DataSourceFilter): Observable<DataSourceResponse<Diagnose>> {
    return this.diagnoseService.getDiagnoses(filter);
  }

  constructor(
    public clinicService: ClinicService,
    public departmentService: DepartmentService,
    public diagnoseService: DiagnoseService
  ) {
    super();

  }



}
